import { B as a } from "./buffer-DIFxvF2Q.js";
class u extends a {
  start() {
    return this._sdk.start();
  }
  stop() {
    return this._sdk.stop();
  }
  recordGauge(r) {
    return this._bufferCall("recordGauge", [r]);
  }
  recordCount(r) {
    return this._bufferCall("recordCount", [r]);
  }
  recordIncr(r) {
    return this._bufferCall("recordIncr", [r]);
  }
  recordHistogram(r) {
    return this._bufferCall("recordHistogram", [r]);
  }
  recordUpDownCounter(r) {
    return this._bufferCall("recordUpDownCounter", [r]);
  }
  // TODO: Ask @vkorolik about using this method before initialization. Doesn't
  // this cause problems if someone tries to work with the returned span?
  startSpan(r, e, t, s) {
    return this._bufferCall("startSpan", [r, e, t, s]);
  }
  startManualSpan(r, e, t, s) {
    return this._bufferCall("startManualSpan", [r, e, t, s]);
  }
  register(r, e) {
    return this._bufferCall("register", [r, e]);
  }
  recordLog(r, e, t) {
    return this._bufferCall("recordLog", [r, e, t]);
  }
  recordError(r, e, t, s, l) {
    return this._bufferCall("recordError", [
      r,
      e,
      t,
      s,
      l
    ]);
  }
  setLDContextKeyAttributes(r) {
    return this._bufferCall("setLDContextKeyAttributes", [r]);
  }
  getLDContextKeyAttributes() {
    return this._bufferCall("getLDContextKeyAttributes", []);
  }
}
let o;
typeof globalThis != "undefined" ? globalThis.LDObserve ? o = globalThis.LDObserve : (o = new u(), globalThis.LDObserve = o) : o = new u();
export {
  o as LDObserve
};
//# sourceMappingURL=LDObserve.js.map
